import React from 'react';

export type CreateStep = 1 | 2 | 3;

export const CREATE_STEPS: { step: CreateStep; label: string }[] = [
  { step: 1, label: 'Project Setup' },
  { step: 2, label: 'Markets' },
  { step: 3, label: 'Review & Create' },
];

type Props = {
  current: CreateStep;
  // Steps the user has opened. One that is not the current step shows a green tick.
  visited: CreateStep[];
  onSelect: (step: CreateStep) => void;
};

// The create page's step strip (prototype .dx-stepper). Every step is clickable.
export const CreateStepper: React.FC<Props> = ({ current, visited, onSelect }) => (
  <ol className="dx-stepper" aria-label="Progress">
    {CREATE_STEPS.map(({ step, label }) => {
      const active = step === current;
      const done = !active && visited.includes(step);
      return (
        <li key={step} className={`dx-step${active ? ' dx-step-active' : ''}${done ? ' dx-step-done' : ''}`}>
          <button type="button" onClick={() => onSelect(step)} aria-current={active ? 'step' : undefined}>
            <span className="dx-step-index">{done ? <span aria-label="visited">✓</span> : step}</span>
            <span>{label}</span>
          </button>
        </li>
      );
    })}
  </ol>
);
